// extracted by mini-css-extract-plugin
module.exports = {"bar":"EvolutionChart_bar__OwTJA","axisLabel":"EvolutionChart_axisLabel__3Xcv0"};